/* Taby Yeni Nesil: shop selector, buy forms, rails, reveals. No dependencies. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Shop selector tabs ---------- */
  function initShop(root) {
    if (root.dataset.tbInit) return;
    root.dataset.tbInit = '1';
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = root.querySelector('#' + t.getAttribute('aria-controls'));
        if (!panel) return;
        if (on) {
          panel.hidden = false;
          if (!reduce) {
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        } else {
          panel.hidden = true;
        }
      });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (e) => {
        let n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') n = tabs[0];
        if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* ---------- Buy forms ---------- */
  function initForm(form) {
    if (form.dataset.tbInit) return;
    form.dataset.tbInit = '1';
    let variants = [];
    try { variants = JSON.parse(form.querySelector('[data-tb-variants]').textContent); } catch (e) { variants = []; }
    const idInput = form.querySelector('[data-tb-variant-id]');
    const btn = form.querySelector('[data-tb-add]');
    const btnText = form.querySelector('[data-tb-add-text]');
    const msg = form.querySelector('[data-tb-msg]');
    const scope = form.closest('[data-tb-product]') || form;
    const priceEl = scope.querySelector('[data-tb-price]');
    const compareEl = scope.querySelector('[data-tb-compare]');
    const label = btn ? btn.dataset.label : 'Sepete ekle';

    const selected = () => {
      const out = [];
      form.querySelectorAll('[data-tb-option]').forEach((el) => {
        const i = parseInt(el.dataset.tbOption, 10);
        if (el.tagName === 'SELECT') out[i] = el.value;
        else {
          const c = el.querySelector('input:checked');
          out[i] = c ? c.value : null;
        }
      });
      return out;
    };

    const sync = () => {
      if (!variants.length) return;
      const sel = selected();
      const v = variants.find((x) => sel.every((val, i) => val == null || x.options[i] === val));
      if (!v) {
        if (btn) { btn.disabled = true; btnText.textContent = 'Mevcut değil'; }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        compareEl.hidden = !v.compare;
        if (v.compare) compareEl.textContent = v.compare;
      }
      if (btn) {
        btn.disabled = !v.available;
        btnText.textContent = v.available ? label : 'Tükendi';
      }
      if (msg) msg.textContent = '';
    };
    form.addEventListener('change', sync);

    form.querySelectorAll('[data-tb-qty]').forEach((b) => {
      b.addEventListener('click', () => {
        const input = form.querySelector('input[name="quantity"]');
        const next = Math.min(99, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.tbQty, 10)));
        input.value = next;
      });
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!btn || btn.disabled) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-disabled', 'true');
      if (msg) msg.textContent = '';
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = new FormData();
      body.append('id', idInput.value);
      const q = form.querySelector('input[name="quantity"]');
      body.append('quantity', q ? q.value : '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map((s) => s.id));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      try {
        const url = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body,
        });
        const data = await res.json();
        if (data.status) {
          if (msg) msg.textContent = data.description || data.message || 'Sepete eklenemedi.';
          return;
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'taby-shop', productVariantId: idInput.value, cartData: data });
        }
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1600);
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (err) {
        if (msg) msg.textContent = 'Bir sorun oluştu, lütfen tekrar deneyin.';
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
      }
    });
    sync();
  }

  /* ---------- Premium Set: 1 to 4 scents (or Kokusuz) before the set goes into the cart ---------- */
  function initScents(form) {
    if (form.dataset.tbInit) return;
    form.dataset.tbInit = '1';
    const MAX = 4;
    const boxes = [...form.querySelectorAll('input[type="checkbox"]')];
    const btn = form.querySelector('[data-tb-add]');
    const btnText = form.querySelector('[data-tb-add-text]');
    const msg = form.querySelector('[data-tb-msg]');
    const count = form.querySelector('[data-tb-count]');
    const label = btn.dataset.label || 'Sepete ekle';
    const soldOut = form.dataset.available === 'false';
    const picked = () => boxes.filter((b) => b.checked);
    const sync = () => {
      const n = picked().length;
      count.textContent = `(${n}/${MAX})`;
      btn.disabled = soldOut || n < 1;
      btnText.textContent = soldOut ? 'Tükendi' : (n < 1 ? 'Önce koku seç' : label);
    };
    boxes.forEach((b) => b.addEventListener('change', () => {
      if (b.checked && picked().length > MAX) {
        b.checked = false;
        msg.textContent = `En fazla ${MAX} farklı koku seçebilirsin.`;
      } else msg.textContent = '';
      sync();
    }));
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const sel = picked();
      if (!sel.length) { msg.textContent = 'Lütfen en az 1 koku seç.'; return; }
      if (btn.disabled) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-disabled', 'true');
      msg.textContent = '';
      // same cart lines as the product page: the set with the chosen scents, then each scent twice
      const items = [{ id: parseInt(form.dataset.set, 10), quantity: 1, properties: { 'Seçilen Kokular': sel.map((b) => b.dataset.label).join(', ') } }]
        .concat(sel.map((b) => ({ id: parseInt(b.value, 10), quantity: 2, properties: { _set: 'Premium Set' } })));
      const payload = { items };
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map((s) => s.id);
        payload.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      try {
        const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const res = await fetch(`${base}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          msg.textContent = data.description || data.message || 'Sepete eklenemedi.';
          return;
        }
        const first = (data.items && data.items[0]) || {};
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'taby-shop', productVariantId: form.dataset.set, cartData: data });
        }
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1600);
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(Object.assign({}, data, { id: first.product_id || form.dataset.set, key: first.key }));
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (err) {
        msg.textContent = 'Bir sorun oluştu, lütfen tekrar deneyin.';
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
        sync();
      }
    });
    sync();
  }

  /* ---------- Rails ---------- */
  function initRail(root) {
    if (root.dataset.tbInit) return;
    root.dataset.tbInit = '1';
    const track = root.querySelector('[data-tb-track]');
    if (!track) return;
    const step = () => {
      const card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    };
    const go = (dir) => track.scrollBy({ left: dir * step() * (window.innerWidth > 990 ? 2 : 1), behavior: reduce ? 'auto' : 'smooth' });
    const prev = root.querySelector('[data-tb-rail-prev]');
    const next = root.querySelector('[data-tb-rail-next]');
    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    track.addEventListener('scroll', sync, { passive: true });
    sync();
    // mouse users can grab and fling the rail; touch keeps native scrolling
    let down = false, moved = 0, x0 = 0, s0 = 0, lastX = 0, lastT = 0, vel = 0, raf = 0;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = 0; x0 = lastX = e.clientX; s0 = track.scrollLeft; lastT = performance.now(); vel = 0;
      cancelAnimationFrame(raf);
      track.classList.add('is-grabbing');
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - x0; moved = Math.max(moved, Math.abs(dx));
      track.scrollLeft = s0 - dx;
      const t = performance.now(); const dt = Math.max(1, t - lastT);
      vel = (e.clientX - lastX) / dt; lastX = e.clientX; lastT = t;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return; down = false;
      let v = -vel * 16;
      const glide = () => {
        v *= 0.92; track.scrollLeft += v;
        if (Math.abs(v) > 0.4 && !reduce) raf = requestAnimationFrame(glide);
        else track.classList.remove('is-grabbing');
      };
      if (!reduce) raf = requestAnimationFrame(glide); else track.classList.remove('is-grabbing');
    });
    track.addEventListener('click', (e) => { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', (e) => e.preventDefault());
  }

  /* ---------- Reveals: one motion language for every block below the film ---------- */
  let revealIO = null;
  function initReveals(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    revealIO = revealIO || new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-seen');
        revealIO.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
    scope.querySelectorAll('[data-tb-reveal], [data-tb-stagger]').forEach((el) => {
      if (el.classList.contains('is-armed')) return;
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) { el.classList.add('is-seen'); }   // already on screen: no entrance
      if (el.hasAttribute('data-tb-stagger')) [...el.children].forEach((c, i) => c.style.setProperty('--i', Math.min(i, 8)));
      el.classList.add('is-armed');
      if (!el.classList.contains('is-seen')) revealIO.observe(el);
    });
  }

  /* ---------- Counters ---------- */
  function initCounters() {
    const els = document.querySelectorAll('[data-tb-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    const fmt = new Intl.NumberFormat('tr-TR');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        const end = parseInt(en.target.dataset.tbCount, 10);
        if (!end || reduce) return;
        const t0 = performance.now();
        const dur = 1400;
        const tick = (t) => {
          const k = Math.min(1, (t - t0) / dur);
          const e = 1 - Math.pow(1 - k, 4);
          en.target.textContent = fmt.format(Math.round(end * e));
          if (k < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    els.forEach((el) => io.observe(el));
  }

  function boot(scope = document) {
    scope.querySelectorAll('[data-tb-shop]').forEach(initShop);
    scope.querySelectorAll('[data-tb-form]').forEach(initForm);
    scope.querySelectorAll('[data-tb-scents]').forEach(initScents);
    scope.querySelectorAll('[data-tb-rail]').forEach(initRail);
    initCounters();
    initReveals(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
